module.exports = __webpack_public_path__ + "static/iphone-sketches@2x-b5f4c85c1efb13ab17ee4c47e7644fe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pop/sketches/iphone-sketches@2x.png
// module id = 929
// module chunks = 173944852332284 271422636699454